import ReactGA from "../../analytics";
import { getInContact } from "../../data/types/events";

import { AUbutton, AUfooter } from "../../ui";
import "./Footer.css";

const Footer = () => (
  <AUfooter dark className="Footer">
    <div className="container">
      <div className="row">
        <AUbutton
          as="secondary"
          link="mailto:looc-c@csiro.au"
          className="Footer__button"
          onClick={() => {
            const { name, params } = getInContact();
            ReactGA.event(name, params);
          }}
        >
          Get in touch
        </AUbutton>
      </div>
    </div>
  </AUfooter>
);

export default Footer;
